module.exports = __webpack_public_path__ + "img/17858_L.bbdd92bd.png";